import {useEffect} from "react";
import { BrowserRouter, Routes, Route } from "react-router";

import LoginPage from "./components/Login/Login.jsx";
import ProtectedRoute from "./components/ProtectedRoute/ProtectedRoute.jsx";
import PricingPage from "./components/PricingPage/PricingPage.jsx";
import Navbar from "./components/Navbar/Navbar.jsx";
import Footer from "./components/Footer/Footer.jsx";
import HomePage from "./components/HomePage/HomePage.jsx";


import "./App.css";
import CriticalFinancePage from "./components/CriticalFinance/CriticalFiancePage.jsx";
import FinancialBuilderPage from "./components/FinancialBuilder/FinancialBuilderPage.jsx";
import FPAPage from "./components/FP&A/FPAPage.jsx";
import PSBBPage from "./components/PSBB/PSBBPage.jsx";
import TemplateRenderWithTemplateID from "./components/TemplateRender/TemplateRender.jsx"


import Dashboard from "./components/Dashboard/Dashboard.jsx";
import SolutionsPage from "./components/Solutions/SolutionsPage.jsx";
import ContactPage from "./components/Contact/ContactPage.jsx";
import PnConfigProvider from "./styles/PnConfigProvider.jsx";

function App() {
  return (
    <PnConfigProvider>
      <BrowserRouter>
        <Routes>
        <Route path="/" element={
          <Body activeKey="home" protectedRoute={true} bodyContent={<HomePage />} />
        } />
        <Route path="/login" element={
          <Body noNavbar={true} noFooter={true} activeKey="login" bodyContent={<LoginPage />} />
        } />
        <Route path="/pricing" element={
          <Body activeKey="pricing" protectedRoute={true} bodyContent={<PricingPage />} />
        } />
        <Route path="/solutions" element={
          <Body activeKey="solutions" protectedRoute={true} bodyContent={<SolutionsPage />} />
        } />
        <Route path="/contact-sales" element={
          <Body activeKey="contact" protectedRoute={true} bodyContent={<ContactPage />} />
        } />
        {/*<Route path="/cfi" element={
          <Body activeKey="cfi" noFooter={true} name="CFI" noNavbar={true} protectedRoute={true} bodyContent={<CriticalFinancePage />} />
        } />*/}
        <Route path="/fb" element={
          <Body activeKey="financial-builder" name="FB" noFooter={true} noNavbar={true} protectedRoute={true} bodyContent={<FinancialBuilderPage />} />
        } />
        <Route path="/fpa" element={
          <Body activeKey="financial-builder" protectedRoute={true} bodyContent={<FPAPage />} />
        } />
        <Route path="/psbb" element={
          <Body activeKey="psbb" name="PSBB" noFooter={true} noNavbar={true} protectedRoute={true} bodyContent={<PSBBPage />} />
        } />
        <Route path="/renderTemplate" element={
          <Body protectedRoute={false} bodyContent={<TemplateRenderWithTemplateID />} />
        } />
        <Route path="/dashboard" element={
          <Body name="Dashboard" protectedRoute={true} activeKey={'dashboard'} bodyContent={<Dashboard />} />
        } />
        </Routes>
      </BrowserRouter>
    </PnConfigProvider>
  );
}


function Body({ bodyContent, activeKey, protectedRoute = false, noNavbar = false, noFooter = false, name = "" }) {
  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo(0, 0);
  }, [bodyContent]);

  // If noNavbar is true, we don't render the Navbar
  return (
    <>
    <title>{name === "" ? "PreNumbers" : "PreNumbers - " + name}</title>
    <div className="home-body">
      {noNavbar ? <></> : <Navbar activeKey={activeKey} />}
      {protectedRoute ? (
        <ProtectedRoute>
          {bodyContent}
        </ProtectedRoute>
      ) : (
        bodyContent
      )}
      {noFooter ? <></> : <Footer />}
    </div>
    </>
  )
}

export default App;